import { render, staticRenderFns } from "./EmailDetailDialog.vue?vue&type=template&id=31d442cc&scoped=true&"
import script from "./EmailDetailDialog.vue?vue&type=script&lang=ts&"
export * from "./EmailDetailDialog.vue?vue&type=script&lang=ts&"
import style0 from "./EmailDetailDialog.vue?vue&type=style&index=0&id=31d442cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d442cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31d442cc')) {
      api.createRecord('31d442cc', component.options)
    } else {
      api.reload('31d442cc', component.options)
    }
    module.hot.accept("./EmailDetailDialog.vue?vue&type=template&id=31d442cc&scoped=true&", function () {
      api.rerender('31d442cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_dialogs/EmailDetailDialog.vue"
export default component.exports